

// export const StatusMainPalette: any = {
//     1: '#28AEF0',
//     2: '#28AEF0',
//     3: '#28AEF0',
//     4: '#28AEF0',
//     5: '#43C464',
//     6: '#43C464',
//     7: '#FF6157',
//     8: '#DE35C1',
//     9: '#FF841F',
//     10: '#7F5AF2',
//     11: '#7C848F',
//     12: '#7C848F',
// }


export enum PaletteStatus {

    BLUE            = 1,
    GREEN           = 5,
    RED             = 7,
    PURPLE          = 8,
    ORANGE          = 9,
    VIOLET          = 10,
    GRAY            = 11

}

